// Some UI strings
export const loggingIn = 'Logging in...';
export const loggedIn = 'Logged in successfully';
export const establishedConnection = 'Connection established';
export const startingSession = 'Starting VU.CITY session';
export const resumingSession = 'Resuming previous VU.CITY session';

// Different states of the UI below the status message
export const modes = {
  error: 'error',
  login: 'login',
  spinner: 'spinner',
  rating: 'rating',
  session: 'session',
  blocked: 'blocked',
  loginDisallowed: 'loginDisallowed',
  featureFlagInput: 'featureFlagInput',
};

// Account data for live
export const dashboardLiveAccount = {
  id: '93118d42-1d9a-4258-b699-fdb3427fc2d9',
  launchpad:
    '347d7709-6758-4364-a06e-87e11205a7df.3a1a72bc-52e4-482d-8bcb-116f31a9872f',
  name: 'vu-dashboard-aws',
  tag: '',
};

// Account data for staging
export const stagingAccountGCP = {
  id: 'd443bf1b-6b54-4ec5-bb98-b47aa958242c',
  launchpad:
    '7396548f-0167-4ba1-a075-eea21630e3b6.270edfe2-6e68-40b2-91ac-22b73be00e12',
  name: 'vustage',
  tag: '[Staging (GCP)]',
};

// Account data for the aws hub live account
export const stagingAccountAWS = {
  id: '255d692f-a626-4bb4-8abe-574e6f563e34',
  launchpad:
    '2578cf6a-d3d5-4354-8a37-6e1abbfe69a6.4b95c0e4-f374-4bc6-86c5-10884cfc68c3',
  name: 'vu-stage-aws',
  tag: '[Staging (AWS)]',
};

export const hubLiveAccountGCP = {
  id: 'b8be03ec-2e79-4e46-9799-715e9264bd06',
  launchpad:
    '4d2af0c4-1708-4ac1-8cd0-7845f7c13573.dc0543c9-ca5f-4387-ae72-4c6785a335f1',
  name: 'vu-hub',
  tag: '',
};

export const hubLiveAccountAWS = {
  id: 'c2a6e296-ff66-4a99-a3bf-fc1306012137',
  launchpad:
    'a5c5e1b2-dce4-44ff-b181-b11135298dec.c25eac98-3fb3-4eb4-8a9f-526cfcb7f223',
  name: 'vu-hub-aws',
  tag: '',
};

// HACK: this is actually just a different launchpad on the live account
export const betaAccount = {
  id: '408f8c47-1344-4459-a817-a825b0f601ba',
  launchpad:
    '35aba927-fa03-4263-b773-d364b9eafa14.446df50a-f339-4188-b736-6b8baac35187',
  name: 'VU.CITY Beta',
  tag: '[Beta]',
};

// HACK: Hardcoded the beta build info here
export const betaApp = {
  id: '0b49d284-9b4b-4f72-b4f3-5da5bb33f138',
  displayName: 'VU.CITY Cloud',
  accountID: 'beta-account',
};

// Dictionary of accounts by account ids
export const accounts = {
  '93118d42-1d9a-4258-b699-fdb3427fc2d9': dashboardLiveAccount,
  'd443bf1b-6b54-4ec5-bb98-b47aa958242c': stagingAccountGCP,
  '255d692f-a626-4bb4-8abe-574e6f563e34': stagingAccountAWS,
  'b8be03ec-2e79-4e46-9799-715e9264bd06': hubLiveAccountGCP,
  'c2a6e296-ff66-4a99-a3bf-fc1306012137': hubLiveAccountAWS,
  'beta-account': betaAccount,
};

// mixpanel events
export const eventNames = {
  loadApps: 'load_applications',
  getToken: 'get_token',
  createTerminal: 'connect_to_frame',
  startSession: 'start_session',
  legacyLogin: 'legacy_login',
  resumeSession: 'resume_session',
  sentRating: 'user_rating',
};
